<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
        <template v-slot:main>
            <head-utils title="Dashboard"/>
            <breadcrumb :items="[{label: 'Dashboard Financeiro', path: '/dash-financial'}]"/>

            <form class="container-fluid-grid" @submit.prevent="submit">
                <div class="form-row">
                    <div class="form-group col-12 col-sm-4 col-md-2">
                        <label for="financialDashSearchStartOne" class="required">Período</label>
                        <select class="form-control form-control-sm"
                                id="financialDashSearchOptionsFilter"
                                @change="changeOptionsFilter"
                                v-model="search_params.option_filter">
                            <option v-for="o in options_filter" :key="o.key" :value="o.key">{{o.label}}</option>
                        </select>
                    </div>
                    <div class="form-group col-6 col-sm-4 col-md-2">
                        <label for="financialDashSearchStartOne" class="required">Mês inicial</label>
                        <MonthYearInput v-model="search_params.start_one"
                                        input_id="financialDashSearchStartOne"
                                        :disabled="search_params.option_filter !== 'custom'"
                                        :input_class="['form-control form-control-sm input plch-c-w t-c', {'is-invalid': errors.start_one}]"/>
                        <field-messages :errors="errors.start_one"/>
                    </div>
                    <div class="form-group col-6 col-sm-4 col-md-2">
                        <label for="financialDashSearchStartTwo" class="required">Mês final</label>
                        <MonthYearInput v-model="search_params.start_two"
                                        input_id="financialDashSearchStartTwo"
                                        :disabled="search_params.option_filter !== 'custom'"
                                        :input_class="['form-control form-control-sm input plch-c-w t-c', {'is-invalid': errors.start_one}]"/>
                        <field-messages :errors="errors.start_two"/>
                    </div>
                    <div class="form-group col-12 col-sm-12 col-md-1 t-c">
                        <label class="t-c">Comparar</label>
                        <div class="checkbox-inline t-c" style="padding: 5px">
                            <label>
                                <input type="checkbox"
                                       v-model="search_params.compare"
                                       @change="changeCompare"
                                       class="checkbox green m"/>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-6 col-sm-4 col-md-2" v-if="search_params.compare">
                        <label for="financialDashSearchEndOne" class="required">Mês inicial</label>
                        <MonthYearInput v-model="search_params.end_one"
                                        input_id="financialDashSearchEndOne"
                                        :input_class="['form-control form-control-sm input plch-c-w t-c', {'is-invalid': errors.end_one}]"/>
                        <field-messages :errors="errors.end_one"/>
                    </div>
                    <div class="form-group col-6 col-sm-4 col-md-2" v-if="search_params.compare">
                        <label for="financialDashSearchEndTwo" class="required">Mês final</label>
                        <MonthYearInput v-model="search_params.end_two"
                                        input_id="financialDashSearchEndTwo"
                                        :input_class="['form-control form-control-sm input plch-c-w t-c', {'is-invalid': errors.end_two}]"/>
                        <field-messages :errors="errors.end_two"/>
                    </div>
                    <div class="form-group col-12 col-sm-4 col-md-1 t-c" v-if="search_params.option_filter === 'custom' || search_params.compare">
                        <div>&nbsp;</div>
                        <button type="submit" class="btn btn-theme-1 btn-sm"><svg-icon icon="search"/> Aplicar</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-6 t-c">
                        <br/>
                        <h2>Total Entradas/Saídas</h2>
                        <div class="doughnut-chart">
                            <ChartJs type="doughnut"
                                     style="background-color: rgba(255,255,255,.2)"
                                     width="100"
                                     height="100"
                                     :data="dataIncomeDoughnut"
                                     :options="optionsDoughnut"/>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 t-c">
                        <br/>
                        <h2>Total Saídas por Tipo</h2>
                        <div class="doughnut-chart">
                            <ChartJs type="doughnut"
                                     style="background-color: rgba(255,255,255,.2)"
                                     width="100"
                                     height="100"
                                     :data="dataOutcomeDoughnut"
                                     :options="optionsDoughnut"/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <br/>
                        <h2 class="t-c">Entradas</h2>
                        <div class="horizontal-chart">
                            <ChartJs type="bar"
                                     style="background-color: rgba(255,255,255,.2)"
                                     :data="dataIncome"
                                     :options="{...optionsValue, responsive: $appUtils.isDesktop()}"/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <br/>
                        <h2 class="t-c">Saídas</h2>
                        <div class="horizontal-chart">
                            <ChartJs type="bar"
                                     style="background-color: rgba(255,255,255,.2)"
                                     :data="dataOutcome"
                                     :options="{...optionsValue, responsive: $appUtils.isDesktop()}"/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <br/>
                        <h2 class="t-c">Emissão de Notas</h2>
                        <div class="horizontal-chart">
                            <ChartJs type="bar"
                                     style="background-color: rgba(255,255,255,.2)"
                                     :data="dataInvoice"
                                     :options="{...optionsValue, responsive: $appUtils.isDesktop()}"/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <br/>
                        <h2 class="t-c">5 Maiores Clientes</h2>
                        <ul class="label_customers">
                            <li v-for="(c, idx) in customers" :key="idx"><span :style="{'background-color': c.backgroundColor}"></span> {{c.label}}</li>
                        </ul>
                        <div class="horizontal-chart">
                            <ChartJs type="bar"
                                     :key="search_params.compare"
                                     style="background-color: rgba(255,255,255,.2)"
                                     :data="dataIncomeCustomer"
                                     :options="{...optionsValueStacked, responsive: $appUtils.isDesktop()}"/>
                        </div>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                    </div>
                </div>
            </form>
        </template>
        <template v-slot:footer>
            <BottomMenuMob v-if="$appUtils.isMobile()"/>
        </template>
    </DefaultTmpl>
</template>

<script>
    import DefaultTmpl from "../templates/DefaultTmpl";
    import BottomMenuMob from "../components/particles/BottomMenuMob";
    import MonthYearInput from "../components/particles/MonthYearInput";
    import dayjs from 'dayjs'
    import ChartJs from "../components/particles/ChartJs";
    import {object2Params, humanizeNumber, formatNumber, isDesktop} from "../utils/Utils";

    const options = {
        THREE_MONTHS: 'three_months_ago',
        SIX_MONTHS: 'six_months_ago',
        TWELVE_MONTHS: 'one_year_ago',
        SAME_3_MONTHS: 'same_three_months_one_year_ago',
        SAME_6_MONTHS: 'same_six_months_one_year_ago',
        PAST_YEAR: 'later_one_year_ago',
        CUSTOM: 'custom',
    };

    const joinXAxis = ' e ';
    const stackCustomer = 'stack_0';

    export default {
        name: "FinancialDashboard",
        components: {MonthYearInput, DefaultTmpl, BottomMenuMob, ChartJs},
        data() {
            return {
                searching: false,
                optionsValue: {
                    maintainAspectRatio: false,
                    legend: {position: 'top'},
                    tooltips: {
                        mode: 'label',
                        callbacks: {
                            title: function(tooltipItems, data) {
                                return `${data.labels[tooltipItems[0].index]}`;
                            },
                            label(tooltipItem, data) {
                                let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                value = value ? formatNumber(value, 2) : '0,00';
                                return `${data.datasets[tooltipItem.datasetIndex].label}: ${value}`;
                            }
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                min: 0,
                                callback: function(label) {
                                    return humanizeNumber(label, 3);
                                }
                            }
                        }]
                    }
                },
                optionsDoughnut: {
                    maintainAspectRatio: false,
                    responsive: true,
                    title: {
                        display: isDesktop()
                    },
                    animation: {
                        animateScale: true,
                        animateRotate: true
                    },
                    legend: {
                        display: isDesktop(),
                        position: 'right'
                    },
                    tooltips: {
                        callbacks: {
                            title: (tooltipItem, data) => data.labels[tooltipItem[0].index],
                            label: (tooltipItem, data) => {
                                return `${data.datasets[tooltipItem.datasetIndex].label} R$ ${formatNumber(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], 2)}`;
                            }
                        }
                    }
                },
                dataIncomeDoughnut: {
                    labels: [],
                    datasets: []
                },
                dataOutcomeDoughnut: {
                    labels: [],
                    datasets: []
                },
                dataIncome: {
                    labels: [],
                    datasets: []
                },
                dataOutcome: {
                    labels: [],
                    datasets: []
                },
                dataInvoice: {
                    labels: [],
                    datasets: []
                },
                dataIncomeCustomer: {
                    labels: [],
                    datasets: []
                },
                search_params: {
                    option_filter: options.SIX_MONTHS,
                    start_one: null,
                    start_two: null,
                    end_one: null,
                    end_two: null,
                    compare: false
                },
                customers: [],
                options_filter: [
                    {label: 'Últimos 3 meses', key: options.THREE_MONTHS},
                    {label: 'Últimos 6 meses', key: options.SIX_MONTHS},
                    {label: 'Últimos 12 meses', key: options.TWELVE_MONTHS},
                    {label: 'Mesmos 3 meses ano passado', key: options.SAME_3_MONTHS},
                    {label: 'Mesmos 6 meses ano passado', key: options.SAME_6_MONTHS},
                    {label: 'Ano passado', key: options.PAST_YEAR},
                    {label: 'Personalizar', key: options.CUSTOM}
                ],
                errors: {}
            }
        },
        methods: {
            createSearchParams() {
                return {
                    option_filter: options.SIX_MONTHS,
                    start_one: null,
                    start_two: null,
                    end_one: null,
                    end_two: null,
                    compare: null,
                }
            },
            submit() {
                if (this.validate())
                    this.$router.push({path: this.$router.currentRoute.path, query: {...this.search_params}});
            },
            filter(params) {
                return this.$appHttp.get(`/v1/financial_dashboard?${params.toString()}`)
            },
            getDates() {
                const tokens0 = this.search_params.start_one.split('/');
                const tokens1 = this.search_params.start_two.split('/');
                const result = {
                    start_one: dayjs().date(1).month(parseInt(tokens0[0]) - 1).year(tokens0[1]),
                    start_two: dayjs().date(1).month(parseInt(tokens1[0]) - 1).year(tokens1[1]),
                };

                if (this.search_params.compare) {
                    const tokens2 = this.search_params.end_one.split('/');
                    const tokens3 = this.search_params.end_two.split('/');

                    result.end_one = dayjs().date(1).month(parseInt(tokens2[0]) - 1).year(tokens2[1]);
                    result.end_two = dayjs().date(1).month(parseInt(tokens3[0]) - 1).year(tokens3[1]);
                }

                return result;
            },
            onFilterSuccess(data) {
                let {start_one, start_two, end_one, end_two} = this.getDates();

                const types = ['income', 'outcome', 'invoice'];
                const colors = {
                    income: ['rgb(89, 179, 73)', 'rgba(89, 179, 73, .3)'],
                    outcome: ['rgb(219, 43, 47)', 'rgba(219, 43, 47, .3)'],
                    taxes: ['rgb(123, 80, 225)', 'rgba(123, 80, 225, .3)'],
                    variable_expenses: ['rgb(255, 165, 0)', 'rgba(255, 165, 0, .3)'],
                    fixed_expenses: ['rgb(219, 43, 47)', 'rgba(219, 43, 47, .3)'],
                    people: ['rgb(19, 158, 201)', 'rgba(19, 158, 201, .3)'],
                    invoice: ['rgb(26, 179, 154)', 'rgba(26, 179, 154, .3)'],
                };

                if (data.total_income_one && data.total_outcome_one) {
                    const chartDoughtnutData = {
                        labels: ['Entradas', 'Saídas'],
                        datasets: [{
                            data: [parseFloat(data.total_income_one), parseFloat(data.total_outcome_one)],
                            backgroundColor: [colors.income[0], colors.outcome[0]],
                            label: `${this.search_params.start_one} à ${this.search_params.start_two}`
                        }]
                    };

                    if (data.total_income_two && data.total_outcome_two) {
                        chartDoughtnutData.datasets.push({
                            data: [parseFloat(data.total_income_two), parseFloat(data.total_outcome_two)],
                            backgroundColor: ['rgba(89, 179, 73, .3)', 'rgba(219, 43, 47, .3)'],
                            label: `${this.search_params.end_one}${joinXAxis}${this.search_params.end_two}`
                        })
                    }

                    this.dataIncomeDoughnut = {...chartDoughtnutData};
                }

                if (data.outcome.type_one) {
                    const dataOutcomeDoughnut = {
                        labels: [],
                        datasets: [{
                            data: [],
                            backgroundColor: [],
                            label: `${this.search_params.start_one}${joinXAxis}${this.search_params.start_two}`
                        }]
                    };
                    Object.keys(data.outcome.type_one).forEach(k => {
                        dataOutcomeDoughnut.labels.push(data.outcome.type_one[k].label);
                        dataOutcomeDoughnut.datasets[0].data.push(data.outcome.type_one[k].value);
                        dataOutcomeDoughnut.datasets[0].backgroundColor.push(colors[k][0]);
                    });


                    if (data.outcome.type_two) {
                        dataOutcomeDoughnut.datasets.push({
                            data: [],
                            backgroundColor: [],
                            label: `${this.search_params.end_one}${joinXAxis}${this.search_params.end_two}`
                        });

                        Object.keys(data.outcome.type_two).forEach(k => {
                            dataOutcomeDoughnut.datasets[1].data.push(data.outcome.type_two[k].value);
                            dataOutcomeDoughnut.datasets[1].backgroundColor.push(colors[k][1]);
                        });
                    }

                    this.dataOutcomeDoughnut = {...dataOutcomeDoughnut};
                }


                types.forEach(t => {
                    if (data[t]) {
                        const chartData = {
                            labels: [],
                            datasets: []
                        };

                        for(let d = start_one.clone(); d.isBefore(start_two, 'month') || d.isSame(start_two, 'month'); d = d.add(1, 'month')) {
                            chartData.labels.push(d.format('MM/YYYY'))
                        }

                        const dataSet = {
                            label: `${this.search_params.start_one}${joinXAxis}${this.search_params.start_two}`,
                            backgroundColor: colors[t][0],
                            borderColor: colors[t][0],
                            data: [],
                            fill: false,
                        };

                        chartData.labels.forEach(l => {
                            let val = data[t].one[l];
                            dataSet.data.push(val ? parseFloat(val) : 0);
                        });

                        chartData.datasets.push(dataSet);

                        if (this.search_params.compare) {
                            const dataSet2 = {
                                label: `${this.search_params.end_one}${joinXAxis}${this.search_params.end_two}`,
                                backgroundColor: colors[t][1],
                                borderColor: colors[t][1],
                                data: [],
                                fill: false,
                            };

                            let count = 0;
                            for(let d = end_one.clone(); d.isBefore(end_two, 'month') || d.isSame(end_two, 'month'); d = d.add(1, 'month')) {
                                let val = data[t].two[d.format('MM/YYYY')];

                                chartData.labels[count] = `${chartData.labels[count]}${joinXAxis}${d.format('MM/YYYY')}`;
                                count++;

                                dataSet2.data.push(val ? parseFloat(val) : 0);
                            }

                            chartData.datasets.push(dataSet2);
                        }

                        this[`data${t.capitalize()}`] = {...chartData};
                    }
                });

                if(data.income.customer_one) {
                    const chartData = {
                        labels: [],
                        datasets: []
                    };

                    for(let d = start_one.clone(); d.isBefore(start_two, 'month') || d.isSame(start_two, 'month'); d = d.add(1, 'month')) {
                        chartData.labels.push(d.format('MM/YYYY'))
                    }

                    const colors = [...Object.keys(this.$appUtils.COLOR_RANGE)];
                    this.$appUtils.fillRandomRGB(colors, data.customers.length);

                    this.customers = [];

                    data.customers.forEach((c, idx) => {

                        let dataTmp = [];

                        chartData.labels.forEach(l => {
                            let val = data.income.customer_one[c.id][l];
                            dataTmp.push(val ? parseFloat(val) : 0);
                        });

                        chartData.datasets.push({
                            label: c.name,
                            stack: stackCustomer,
                            backgroundColor: `rgba(${colors[idx]}, 1)`,
                            data: dataTmp
                        });

                        this.customers.push({
                            label: c.name,
                            backgroundColor: `rgba(${colors[idx]}, 1)`
                        });

                        if (!this.search_params.compare) {
                            chartData.datasets.forEach(d => {
                                delete d.stack;
                            })
                        }

                        if(data.income.customer_two) {

                            dataTmp = [];

                            for(let d = end_one.clone(); d.isBefore(end_two, 'month') || d.isSame(end_two, 'month'); d = d.add(1, 'month')) {
                                let val = data.income.customer_two[c.id][d.format('MM/YYYY')];
                                dataTmp.push(val ? parseFloat(val) : 0);
                            }

                            chartData.datasets.push({
                                label: c.name,
                                stack: 'stack_1',
                                backgroundColor: `rgba(${colors[idx]}, 1)`,
                                data: dataTmp
                            });
                        }
                    });

                    if(data.income.customer_two) {
                        let count = 0;
                        for (let d = end_one.clone(); d.isBefore(end_two, 'month') || d.isSame(end_two, 'month'); d = d.add(1, 'month')) {
                            chartData.labels[count] = `${chartData.labels[count]}${joinXAxis}${d.format('MM/YYYY')}`;
                            count++;
                        }
                    }

                    this.dataIncomeCustomer = {...chartData};
                }
            },
            validate() {
                let {start_one, start_two, end_one, end_two} = this.getDates();
                this.errors = {};

                const diff1 = start_two.diff(start_one, 'month');

                if (start_one.isAfter(start_two)) this.$set(this.errors, 'start_one', ['Data início maior que data final']);
                else if (diff1 < 1) this.$set(this.errors, 'start_two', ['Período deve ter no mínimo dois meses']);
                else if (diff1 >= 12) this.$set(this.errors, 'start_two', ['Período deve ter no máximo doze meses']);

                if (end_one && end_two) {
                    if (end_one.isAfter(end_two)) this.$set(this.errors, 'end_one', ['Data início maior que data final']);
                    else if (diff1 !== end_two.diff(end_one, 'month')) this.$set(this.errors, 'end_two', ['Quantidade de meses diferente do período a ser comparado']);
                }

                return Object.keys(this.errors).length === 0;

            },
            changeOptionsFilter() {
                const now = dayjs();
                let months = 0;
                switch (this.search_params.option_filter) {
                    case options.THREE_MONTHS:
                        months = 2;
                    case options.SIX_MONTHS:
                        if (!months) months = 5;
                    case options.TWELVE_MONTHS:
                        if (!months) months = 11;
                        this.search_params.start_one = now.subtract(months, 'months').startOf('month').format('MM/YYYY');
                        this.search_params.start_two = now.endOf('month').format('MM/YYYY');
                        break;
                    case options.SAME_3_MONTHS:
                        months = 2;
                    case options.SAME_6_MONTHS:
                        if (!months) months = 5;
                    case options.PAST_YEAR:
                        if (!months) months = 11;

                        let date = now.subtract(1, 'year');
                        let date2 = null;
                        if (months === 11) {
                            date2 = date.endOf('year');
                            date = date.startOf('year');
                        } else {
                            date2 = date.endOf('month');
                            date = date.subtract(months, 'month').startOf('month');
                        }

                        this.search_params.start_one = date.format('MM/YYYY');
                        this.search_params.start_two = date2.format('MM/YYYY');

                        break;
                }

                this.changeCompare();
            },
            changeCompare() {
                if (this.search_params.compare) {
                    let tokens1 = this.search_params.start_one.split('/');
                    let tokens2 = this.search_params.start_two.split('/');
                    let date_start = dayjs().date(1).month(parseInt(tokens1[0]) - 1).year(tokens1[1]);
                    let date_end = dayjs().date(1).month(parseInt(tokens2[0]) - 1).year(tokens2[1]);

                    const diff = date_start.diff(date_end, 'month') * -1;
                    date_end = date_start.subtract(1, 'month');
                    date_start = date_end.subtract(diff, 'month');

                    this.search_params.end_one = date_start.format('MM/YYYY');
                    this.search_params.end_two = date_end.format('MM/YYYY');
                } else {
                    this.search_params.end_one = null;
                    this.search_params.end_two = null;
                }

                this.submit();
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.search_params = {...vm.createSearchParams(), ...(to.query || {})};
                vm.changeOptionsFilter();

                vm.search_params.compare = to.query.compare;

                const params = object2Params(vm.search_params);

                vm.searching = true;
                vm.filter(params)
                    .then(({data}) => vm.onFilterSuccess(data))
                    .finally(() => vm.searching = false);
            });
        },
        beforeRouteUpdate(to, from, next) {
            const params = object2Params(to.query);

            this.searching = true;
            this.filter(params)
                .then(({data}) => this.onFilterSuccess(data))
                .finally(() => this.searching = false)
            ;
            next();
        },
        computed: {
            optionsValueStacked() {
                if (!this.search_params.compare) return {...this.optionsValue, legend: false};

                return {
                    maintainAspectRatio: false,
                    legend: {display: false},
                    tooltips: {
                        mode: 'nearest',
                        callbacks: {
                            title: function(tooltipItems, data) {
                                const stack = data.datasets[tooltipItems[0].datasetIndex].stack;
                                let tokens = `${data.labels[tooltipItems[0].index]}`.split(joinXAxis);

                                if (stack === stackCustomer) return tokens[0];

                                return tokens[1];
                            },
                            label(tooltipItem, data) {
                                let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                value = value ? formatNumber(value, 2) : '0,00';
                                return `${data.datasets[tooltipItem.datasetIndex].label}: ${value}`;
                            }
                        }
                    },
                    scales: {
                        yAxes: [{
                            stacked: true,
                            ticks: {
                                min: 0,
                                callback: function(label) {
                                    return humanizeNumber(label, 3);
                                }
                            }
                        }],
                        xAxes: [{
                            stacked: true
                        }]
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .horizontal-chart {
        position: relative;
        height: 300px;
        width: calc(100vw - 240px);
        overflow-x: auto;
    }

    .collapsed {
        .horizontal-chart {
            width: calc(100vw - 90px);
        }
    }

    .doughnut-chart {
        display: inline-flex;
        justify-content: center;
        position: relative;
        max-width: 600px;
        width: 100%;
        height: 300px;
    }

    .label_customers {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        list-style: none;
        padding: 0;
        margin: 0;

        li {
            font-size: .8em;
            display: flex;
            align-items: center;

            &:not(:first-child) {
                margin-left: 15px;
            }
        }

        span {
            display: inline-block;
            width: 45px;
            height: 1.2em;
            margin-right: 5px;
        }
    }



    @media (max-width: 800px) {
        .horizontal-chart {
            width: 100%;
        }
    }
</style>
